/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetIoeContent200ResponseFaqsInner
 */
export interface GetIoeContent200ResponseFaqsInner {
    /**
     * Section title (e.g. "Overview", "Risk Details", "Remediation").
     */
    title?: string;
    /**
     * Markdown-formatted body text for this section.
     */
    text?: string;
    /**
     * Whether this section should be expanded by default in the UI.
     */
    open?: boolean;
}

/**
 * Check if a given object implements the GetIoeContent200ResponseFaqsInner interface.
 */
export function instanceOfGetIoeContent200ResponseFaqsInner(value: object): value is GetIoeContent200ResponseFaqsInner {
    return true;
}

export function GetIoeContent200ResponseFaqsInnerFromJSON(json: any): GetIoeContent200ResponseFaqsInner {
    return GetIoeContent200ResponseFaqsInnerFromJSONTyped(json, false);
}

export function GetIoeContent200ResponseFaqsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIoeContent200ResponseFaqsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'text': json['text'] == null ? undefined : json['text'],
        'open': json['open'] == null ? undefined : json['open'],
    };
}

export function GetIoeContent200ResponseFaqsInnerToJSON(json: any): GetIoeContent200ResponseFaqsInner {
    return GetIoeContent200ResponseFaqsInnerToJSONTyped(json, false);
}

export function GetIoeContent200ResponseFaqsInnerToJSONTyped(value?: GetIoeContent200ResponseFaqsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'text': value['text'],
        'open': value['open'],
    };
}

